// extracted by mini-css-extract-plugin
module.exports = {"featuredImage":"FeaturedImage_featuredImage__bheWa"};